import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PostAttachmentPicker } from '../../utils/post-attachment';

/** The thumbnails (or video) a composer is about to post, each with a × to take it off. */
@Component({
  selector: 'app-social-attachment-preview',
  templateUrl: './social-attachment-preview.component.html',
  styleUrls: ['./social-attachment-preview.component.scss'],
  standalone: false,
  // Angular 22 defaults to OnPush; this one reads an object its parent changes in place
  // (the `picker` input keeps the same reference), so it has to be checked on every pass.
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SocialAttachmentPreviewComponent {
  @Input({ required: true }) picker!: PostAttachmentPicker;
}
